
import { Component, Vue, Prop } from "vue-property-decorator";

import { COMPLETED_TASK_STATUS, ARCHIVED_TASK_STATUS } from "@/constants/tasks";

const CHECKMARK_ICON = "checkmark-sharp";

const ENUM_CLASS = "enum";

@Component({})
export default class Compliance extends Vue {
  @Prop({ type: String, default: "" }) readonly count!: string;
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly description!: string;
  @Prop({ type: String, default: "" }) readonly button!: string;
  @Prop({ type: String, default: "" }) readonly status!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  checkIcon = CHECKMARK_ICON;

  onClick() {
    this.$emit("click");
  }

  get classes() {
    const { count } = this;

    return {
      [`${ENUM_CLASS}_gap`]: count !== "1",
    };
  }

  get showTick() {
    return this.status === COMPLETED_TASK_STATUS || this.status === ARCHIVED_TASK_STATUS;
  }

  get showButton() {
    return this.button && !this.showTick;
  }
}
